import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m40 20.555c0 11.045-8.954 20-20 20s-20-8.955-20-20c0-11.046 8.954-20 20-20s20 8.954 20 20",
  fill: "#F39608",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.852 22.995l-8.24-9.548-2.12 5.292-9.132-9.15-6.866 4.925-2.525.765-1.378 2.943-2.217 3.635 4.468 5.174 4.51 3.589-1.224 2.362 9.053 7.135c8.262-1.758 14.636-8.616 15.67-17.122",
  fill: "#E8620B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.547 25.414l-1.605-3.899s-.408-.844-.84-.012c-.28.54-5.95 11.007-5.95 11.007s-.273.477.268.65c.455.148 9.256 2.947 12.08 3.63.579.137.506-.547.506-.547l-1.472-3.575s17.734-12.66-.614-24.033c8.314 11.274-2.373 16.78-2.373 16.78",
  fill: "#FDF8D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.31 15.21l1.18 2.868s.3.62.616.009c.206-.397 4.377-8.094 4.377-8.094s.2-.351-.198-.479c-.335-.108-6.806-2.166-8.884-2.668-.425-.101-.37.402-.37.402l1.082 2.629s-13.04 9.309.45 17.672C6.452 19.259 14.31 15.21 14.31 15.21",
  fill: "#4B397F"
})), 'CertainExchange', {
  viewBox: '0 0 40 40'
});